(function($) {

    /*------------------------------------*\
        VARIABLES
    \*------------------------------------*/

    // ### Custom vars
    var $header_nav = $("#nav_menu");



    /*------------------------------------*\
        INIT
    \*------------------------------------*/


    // ### Foundation 6
    $(document).foundation();

    console.log("Current media query: "+Foundation.MediaQuery.current);


    // ### JS Proov
    // Owl Carousel
    var $carousel_partenaires = $("#partenaires_carousel");
    var loop = false;
    if ( $carousel_partenaires.find("div[class*=item]").length > 5 ){
        loop = true;
    }
    $carousel_partenaires.owlCarousel({
        loop: loop,
        lazyLoad: true,
        nav: false,
        autoplay: 6000,
        responsive:{
            0:{
                items: 2,
                nav: false,
                dots: false
            },
            640:{
                items: 3,
                nav: true
            },
            1024:{
                items: 5,
                nav: true
            }
        }
    });
    // Isotope
    var $masonry = $("#isotope");
    $masonry.imagesLoaded().progress( function( instance, image ) {
        var self = $(image.img);
        self.parents(".masonry-item").addClass("loaded");
        $masonry.isotope('layout');
    });
    $masonry.isotope({
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer'
        },
        itemSelector: '.masonry-item',
        percentPosition: true
    });


    // Popup Newsletter
    if ( $("#text-5").length ){
        var $btn_newsletter = $("#text-5").find("a");
        $btn_newsletter.on('click', function(e){
            e.preventDefault();
            $("#modal_newsletter").foundation('open');
        });
    }

    // Animate Numbers
    var $page_chiffres = $(".page__chiffres");
    if( $page_chiffres.length ){

        // onScreen.js viewport detector
        var os = new OnScreen({
            tolerance: 0,
            debounce: 150,
            container: window
        });

        // Enter viewport
        var once = true;

        os.on('enter', '.page__chiffres .item .chiffre', (element) => {


            if(!element.classList.contains("done")){
                element.classList.add("done");
                var nb = parseInt(element.innerHTML);
                $(element).animateNumber({
                    number: nb,
                    easing: 'easeOutQuad'
                }, 3500);
            }

        });

    }


    var fixed_menu   = $('#fixed_menu_top');
    var position_top = $('#menu-top-menu').position().top;
    var menu_height  = $('#menu-top-menu').height();

    if ( fixed_menu.length  ) {

        var processing = false;
        $(window).scroll(function() {
            if (processing) {
                return false;
            }
            processing = true;

            setTimeout(function() {
                ( $(window).scrollTop() > position_top + menu_height ) ? fixed_menu.show() : fixed_menu.hide();
                processing = false;
            }, 250)
        });
    }

    // Trigger first window scroll manually
    $(window).scroll();


    // ### JS Djay-Djay
    var page_id = 1;
    var enabled = true;

    // Ajax News Pagination
    $( '.load_more_news' ).on("click", function(e) {
        e.preventDefault();
        if( enabled ){
            enabled = false;
            $( this ).addClass( 'loading' );
            var data = {
                action: "load_more_news",
                page_id : page_id++,
            };
            $.post(ajaxurl, data, function(response){
                if ( response['status'] ) {
                    $( '.load_more_news' ).removeAttr( 'disabled' );
                    $( '.load_more_news' ).removeClass( 'loading' );
                    $( '.row.content' ).html( $( '.row.content' ).html() + response['response'] );
                    enabled = true;
                }
                else {
                    alert( 'Une erreur est survenue sur le chargement des actualités' );
                    enabled = true;
                }

                if( response['hide_button'] ){
                    $( '.load_more_news' ).fadeOut();
                }

            }, 'json');
        }
    });

    // ### JS Foundation Press
    $( 'iframe[src*="youtube.com"]' ).wrap("<div class='flex-video widescreen'/>");
    $( 'iframe[src*="vimeo.com"]' ).wrap("<div class='flex-video widescreen vimeo'/>");


    /*------------------------------------*\
        MOBILE
    \*------------------------------------*/

    if( (Foundation.MediaQuery.current === 'small') || (Foundation.MediaQuery.current === 'medium') ){

        // ### Toggle responsive Menu
        // In vanilla JS for better perfs u know what im sayin' FloFlo ?
        var menu_trigger_el = document.getElementById("trigger_menu");
        function triggerMenu (e) {
            e.preventDefault();
            document.body.classList.toggle("nav-open");
        }
        menu_trigger_el.addEventListener("click", triggerMenu, false);

        // Clone current menu
        $header_nav.clone().removeClass("show-for-large").addClass("responsive").appendTo("#hero");
    };


})(jQuery); // Fully reference jQuery after this point.
